// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"844633be","209":"e84591e5","478":"1f23b20b","562":"732bbff6","922":"b33a7810","964":"42031f72","977":"6f676005"}[chunkId] + ".chunk.js";
};